import { useBucket } from '@mc/experiments-react'

import { EXPERIMENT_KEY } from './useTrackPen5038ExperimentViewed'
import { useExperimentCriteria } from './useExperimentCriteria'

export const usePen5038Experiment = () => {
  const isEnabled = useBucket(EXPERIMENT_KEY)?.includes('variant')
  const experimentCriteria = useExperimentCriteria()

  return {
    isEnabled: isEnabled && experimentCriteria,
  }
}
